import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '../../store';
import { OverlayService } from '../../services/overlay.service';
import { ProductsService } from '../../services/products.service';
import { ToolsService } from '../../services/tools.service';
import { AddressService } from 'src/app/services/address.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-range',
    templateUrl: './range.component.html',
    styleUrls: ['./range.component.scss']
})
export class RangeComponent implements OnInit {
    @Input() company;
    @Input() productRange;
    @Output() next = new EventEmitter();
    @Output() productRangeUpdated = new EventEmitter();

    env = environment;

    form: FormGroup;
    uploadConfig: any;
    resizeWidth: 500;
    newItem = true;
    productRanges = [];
    standardPricing = [];
   addressData:any;

    constructor(
        private store: Store,
        private overlayService: OverlayService,
        private productsService: ProductsService,
        private fb: FormBuilder,
        private toolsService: ToolsService,
        private addressService:AddressService
    ) {
        this.form = this.fb.group({
            name: ['', [Validators.required, Validators.minLength(3)]],
            tileText: ['', []],
            bannerText: ['', []],
            previewText: ['', []],
            description: ['', []],
            parent: [0, []],
            baseCost: [0, [Validators.required]],
            baseWeight: [0, [Validators.required]],
            slug: ['', [Validators.required, Validators.minLength(3)]],
            available: [1, []],
            imageUrl: ['', []],
            showInMainMenu: [false, []],
            showInPreviewSlider: [false, []]
        });




    }

    ngOnInit(): void {

        this.addressService.collectionData$.subscribe(data => {
            this.addressData = data;
        });
        this.productsService.getProductRangesBySupplier(this.company.id).subscribe(data => {
            this.productRanges = data.data;

            if (this.productRange) {
                this.newItem = false;
                this.setRange(this.productRange);
            }

            if (!this.productRanges.length) {
                this.newItem = true;
                this.setRange({
                    name: '',
                    tileText: '',
                    bannerText: '',
                    previewText: '',
                    description: '',
                    supplier: this.company.id,
                    slug: '',
                    level: 0,
                    parent: 0,
                    available: 1,
                    baseCost: 0,
                    baseWeight: 0,
                    productTypes: [],
                    imageUrl: '',
                    showInMainMenu: false,
                    showInPreviewSlider: false,
                    standardPricing: [],
                });
            }
            if (this.productRanges.length === 1) {
                this.newItem = false;
                this.setRange(this.productRanges[0]);
            }
        });

        this.initUpload();
    }

    setRange(range) {
        this.productRange = range;
        this.standardPricing = range.standardPricing;

        this.form.patchValue({
            name: this.productRange.name,
            tileText: this.productRange.tileText,
            bannerText: this.productRange.bannerText,
            previewText: this.productRange.previewText,
            description: this.productRange.description,
            supplier: this.company.id,
            slug: this.productRange.slug,
            available: this.productRange.available,
            baseCost: this.productRange.baseCost,
            baseWeight: this.productRange.baseWeight,
            imageUrl: this.productRange.imageUrl,
            parent: this.productRange.parent,
            showInMainMenu: this.productRange.showInMainMenu,
            showInPreviewSlider: this.productRange.showInPreviewSlider,
        });
    }

    togglePreviewSlider() {
        if (!this.form.value.showInPreviewSlider) {
            this.form.patchValue({ showInPreviewSlider: true });
        } else {
            this.form.patchValue({ showInPreviewSlider: false });
        }
    }
    toggleMainMenu() {
        if (!this.form.value.showInMainMenu) {
            this.form.patchValue({ showInMainMenu: true });
        } else {
            this.form.patchValue({ showInMainMenu: false });
        }
    }
    toggleAvailable() {
        if (!this.form.value.available) {
            this.form.patchValue({ available: true });
        } else {
            this.form.patchValue({ available: false });
        }
    }


    onSubmit() {
        this.productRange.name = this.form.value.name;
        this.productRange.tileText = this.form.value.tileText;
        this.productRange.bannerText = this.form.value.bannerText;
        this.productRange.previewText = this.form.value.previewText;
        this.productRange.description = this.form.value.description;
        this.productRange.slug = this.form.value.slug;
        this.productRange.available = this.form.value.available;
        this.productRange.baseCost = this.form.value.baseCost;
        this.productRange.baseWeight = this.form.value.baseWeight;
        this.productRange.imageUrl = this.form.value.imageUrl;
        this.productRange.parent = this.form.value.parent;
        this.productRange.showInMainMenu = this.form.value.showInMainMenu;
        this.productRange.showInPreviewSlider = this.form.value.showInPreviewSlider;
        if (this.productRange.parent > 0) {
            this.productRange.level = 1;
        }

        if (!this.productRange.id) {
            this.productsService.createProductRange(this.productRange).subscribe(data => {
                this.productRange = data.data;
                this.productRangeUpdated.emit(data.data);
                this.next.emit();
            });

        } else {
            this.productsService.updateProductRange(this.productRange).subscribe(data => {
                this.productRangeUpdated.emit(this.productRange);
                this.next.emit();
            });
        }
    }

    initUpload() {
        this.uploadConfig = {

            url: this.env.imageUploadPath + 'products/upload/image',
            acceptedFiles: 'image/*',
            parallelUploads: 1,
            resizeWidth: this.resizeWidth,
            maxFiles: 1,
            maxFilesize: 5120,
            // The API's upload routes now require the admin session: send the cookie and
            // the app-name the API uses to pick auth.app.admin (Dropzone bypasses the interceptor).
            withCredentials: true,
            headers: {
                'api-key': '6bf9284a-ebf9-4afa-a185-4d2b9bb29e85',
                'app-name': 'admin'
            },
        };
    }

    onUploadError(e) {
        this.initUpload();
    }

    onUploadSuccess(e) {
        this.form.patchValue({
            imageUrl: e[1].data
        });
        this.initUpload();
    }

    uploadprogress(e) {
    }

    deleteImage() {
        this.form.patchValue({ imageUrl: '' });
    }

}
